module.exports = new __parcel__URL__("DACI Hover.236fac19.svg").toString();